import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FaCheckCircle, FaClipboardCheck } from 'react-icons/fa'
import {
  Badge,
  BtnIcon,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  PageHeader,
  ThreeDots,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { openReportInNewTab } from '../../../../services/util/report.service'
import * as colors from '../../../../assets/js/colors'
import {
  parsePreenchimentoStatus,
  PreenchimentoStatus,
  ROTAS_CHECKLIST,
} from '../../../../constants/checklist-operacional'
import {
  urlReportPreenchimento,
  urlReportPreenchimentoResultado,
} from '../../../../services/api/routes/checklist-operacional.routes'
import { formatarDataHora } from '../shared/respostas.util'
import usePreenchimentoChecklist, {
  ACOES,
  LOAD_MESSAGE,
  MENU_ITEMS,
  validarAcao,
} from './PreenchimentoChecklistHook'
import ModalPreenchimento from './ModalPreenchimento/ModalPreenchimento'

function PreenchimentoChecklist({ selectedTp, dispatch, history }) {
  const { state, localDispatch } = usePreenchimentoChecklist()

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.INITIAL_GET:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.getPreenchimentos(state.selectedTp)
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.save(state.selectedTp, state.preenchimentoSalvar)
        break
      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox(state.loadingMessage, 'Aguarde...'))
        localDispatch.delete(state.selectedTp, state.preenchimentoExcluir)
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.clearMessages()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.clearMessages()
    }
  }, [state.successMessage])

  const abrirPreencher = (preenchimento, modo) =>
    history.push(ROTAS_CHECKLIST.PREENCHER, { preenchimentoId: preenchimento.id, modo })

  const onMenuItemClicked = (acao, preenchimento) => {
    const erro = validarAcao(acao, preenchimento)
    if (erro) return localDispatch.setError(erro)

    switch (acao) {
      case ACOES.EDITAR:
        return localDispatch.toggleModal(true, preenchimento)
      case ACOES.IMPRIMIR:
        return openReportInNewTab(urlReportPreenchimento(selectedTp, preenchimento.id))
      case ACOES.PREENCHER:
        return abrirPreencher(preenchimento, 'preencher')
      case ACOES.VER_RESULTADO:
        return abrirPreencher(preenchimento, 'resultado')
      case ACOES.IMPRIMIR_RESULTADO:
        return openReportInNewTab(urlReportPreenchimentoResultado(selectedTp, preenchimento.id))
      case ACOES.EXCLUIR:
        return localDispatch.onExcluirClicked(preenchimento)
      default:
        return null
    }
  }

  const iconePreencher = preenchimento => {
    if (preenchimento.status === PreenchimentoStatus.Finalizado.label) {
      return (
        <BtnIcon onClick={() => onMenuItemClicked(ACOES.VER_RESULTADO, preenchimento)}>
          <FaCheckCircle color={colors.verde_success} title="Ver resultado" />
        </BtnIcon>
      )
    }

    const expirado = preenchimento.status === PreenchimentoStatus.Expirado.label
    return (
      <BtnIcon onClick={() => onMenuItemClicked(ACOES.PREENCHER, preenchimento)}>
        <FaClipboardCheck color={expirado ? colors.gray : colors.azul} title="Preencher" />
      </BtnIcon>
    )
  }

  const header = (
    <CustomDataTableHeader
      onChange={value => localDispatch.onGlobalFilterChange(value)}
      value={state.globalFilter}
    />
  )

  return (
    <div>
      <PageHeader>10.2 - Preenchimento de Checklist</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.toggleModal(true, null)}
          showBtnNovo={!!selectedTp}
          onVoltar={() => history.push(ROTAS_CHECKLIST.MENU)}
        >
          <DataTable
            header={header}
            value={state.preenchimentos}
            paginator
            rows={15}
            globalFilter={state.globalFilter}
            emptyMessage="Nenhum preenchimento encontrado"
            dataKey="id"
          >
            <Column field="checklist_code" header="Código" style={{ width: 130 }} />
            <Column field="title" header="Formulário" />
            <Column field="company_name" header="Empresa" />
            <Column
              field="created_at"
              header="Criado em"
              body={row => formatarDataHora(row.created_at)}
              style={tableCellCentered(130)}
            />
            <Column
              field="deadline"
              header="Deadline"
              body={row => formatarDataHora(row.deadline) || '-'}
              style={tableCellCentered(130)}
            />
            <Column field="responsavel" header="Responsável" />
            <Column
              field="status"
              header="Status"
              body={row => {
                const status = parsePreenchimentoStatus(row.status)
                return <Badge color={status.color}>{status.label}</Badge>
              }}
              style={tableCellCentered(110)}
            />
            <Column header="Preencher" body={iconePreencher} style={tableCellCentered(90)} />
            <Column
              header="Menu"
              body={row => (
                <ThreeDots items={MENU_ITEMS} onClick={acao => onMenuItemClicked(acao, row)} />
              )}
              style={tableCellCentered(70)}
            />
          </DataTable>
        </CustomPanel>
      </div>

      <ModalPreenchimento
        show={state.showModal}
        preenchimento={state.preenchimentoEdicao}
        formInit={state.formInit}
        onClose={() => localDispatch.toggleModal(false, null)}
        onSave={localDispatch.onModalSave}
        onError={erro => dispatch(showMessageBox(null, erro))}
      />
      <ConfirmDialog
        isVisible={!!state.preenchimentoExcluir && state.loadingMessage === LOAD_MESSAGE.NONE}
        title="Atenção"
        content={
          <span>
            Tem certeza que deseja excluir este preenchimento? Esta ação é permanente e não poderá
            ser desfeita.
          </span>
        }
        okLabel="EXCLUIR"
        onCancelar={() => localDispatch.onConfirmExcluir(false)}
        onOk={() => localDispatch.onConfirmExcluir(true)}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(PreenchimentoChecklist))
